import { useEffect, useState } from "react";
import { Button } from "@oc-labs/wt-storybook";
import useEvent from "../../../hooks/useEvent";

export default function AttendeesList({ hideAttendeesList, attendees }) {
  const { getMembers } = useEvent();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const enrichAttendees = async () => {
      try {
        const members = await getMembers();
        const membersMap = new Map(members.map((m) => [m.id, m]));

        // attendees puede venir como { atendees: [...] } o [] directamente
        const attendeesArray = Array.isArray(attendees.atendees)
          ? attendees.atendees
          : Array.isArray(attendees)
          ? attendees
          : [];

        const enriched = attendeesArray.map((a) => {
          const member = membersMap.get(a.attendeeId);
          return {
            id: a.attendeeId,
            displayName: member ? member.name || member.email : "Unknown",
            email: member ? member.email : "Unknown",
            phone: member ? member.phoneNumber || "Unknown" : "Unknown",
          };
        });

        setList(enriched);
      } catch (e) {
        console.error("Failed to enrich attendees:", e);
        setList([]); // fallback
      } finally {
        setLoading(false);
      }
    };

    enrichAttendees();
  }, [attendees]);

  return (
    <div className="p-6 w-full mx-auto">
      <div className="flex items-center justify-between mb-4 mx-2">
        <div className="flex">
          <Button
            type="secondary"
            size="small"
            onClick={hideAttendeesList}
          >
            Back
          </Button>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 shadow-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-sm font-semibold text-gray-700 tracking-wide">Name</th>
                <th className="px-6 py-4 text-sm font-semibold text-gray-700 tracking-wide">Email</th>
                <th className="px-6 py-4 text-sm font-semibold text-gray-700 tracking-wide">Phone</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading && (
                <tr>
                  <td className="px-6 py-6 text-sm text-gray-500" colSpan={3}>
                    Loading attendees...
                  </td>
                </tr>
              )}
              {!loading && list.length === 0 && (
                <tr>
                  <td className="px-6 py-6 text-sm text-gray-500" colSpan={3}>
                    No attendees found.
                  </td>
                </tr>
              )}
              {!loading &&
                list.map((attendee) => (
                  <tr
                    key={attendee.id}
                    className="transition duration-300 hover:bg-gray-100"
                  >
                    <td className="px-6 py-4">
                      <div className="flex flex-col">
                        <span className="text-sm font-medium text-gray-800">{attendee.displayName}</span>
                        <span className="text-xs text-gray-400">ID: {attendee.id}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-700">{attendee.email}</td>
                    <td className="px-6 py-4 text-sm text-gray-700">{attendee.phone}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}